<template lang="pug">
  .shipping-step
    validation-provider(:rules="{ required: { allowFalse: false } }")
      input.hidden(type="checkbox" :value="!!shipping.id")

    //- .shipping-methods(v-if="methods.length > 1")
    //-   h4.panel-heading Versandart
    .alert.error(v-if="!methods.length")
      p Momentan stehen keine Versandmethoden zur Verfügung.
    template(v-else)
      .shipping-methods
        .panel.mb-8
          .box
            ShippingMethod(
              v-for="(method, i) in methods" :key="method.id"
              :data="method"
              :active="method.id === shipping.id"
              :show-divider="i + 1 < methods.length"
              @select="select"
            )
              template(v-if="methods.length === 1" v-slot:icon)
                svg(
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                )
                  //- d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
                  path(
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.3"
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                  )

      .desired-delivery-date(v-if="desiredDeliveryDateOptions.length")
        h4.panel-heading Wunschlieferdatum
        .select-panel-wrap.mb-8
          validation-provider(ref="select" name="Wunschlieferdatum" :rules="desiredDeliveryDateRules" v-slot="{ errors }")
            .panel.overflow-visible(:class="{ error: errors && errors.length }")
              .box
                .preview
                  .icon
                    svg(
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    )
                      path(
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.3"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      )
                  .data
                    .field
                      fieldset.form-field
                        multiselect(
                          v-model="shouldBeDeliveredAt"
                          :options="desiredDeliveryDateOptions"
                          :multiple="false"
                          :searchable="false"
                          :allow-empty="!desiredDeliveryDateRequired"
                          :show-labels="true"
                          track-by="key"
                          label="label"
                          placeholder="Datum wählen..."
                          deselect-label=""
                          selected-label=""
                          select-label=""
                        )
            p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
            //- p.help.has-text-grey(v-else-if="desiredDeliveryDateRequired") Pflichtfeld

            //- hr.my-4
            //- // TODO: multiple addresses / add address
            //- AddressForm(type="shipping" label="Lieferadresse" :show-name="true")

      .shipping-addresses
        h4.panel-heading Lieferadresse
        .panel.mb-8
          .box
            Address(
              v-for="(address, i) in addresses" :key="address.id"
              :data="address"
              :active="address.id === shippingAddress.id"
              :show-divider="true"
              :show-label="false"
              @select="setShippingAddress"
            )
            //- AddressForm(
            //-   label="Lieferadresse"
            //-   type="shipping"
            //-   :show-name="editName"
            //-   :show-label="false"
            //-   :show-checkbox="addresses.length >= 1"
            //-   :active="showAddressForm"
            //-   @select="setShippingAddress"
            //-   @edit="editAddress = true"
            //- )
</template>

<script>
import uniqid from 'uniqid';
import { formatTimestamp, date2timestamp } from '@/filters';

import { mapGetters, mapMutations } from 'vuex';
import { get, cloneDeep } from '@/helpers';

import Multiselect from 'vue-multiselect';
import ShippingMethod from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/ShippingMethod';
import AddressForm from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/AddressForm';
import Address from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/Address';

export default {
    name: 'ShippingStep',
    props: {
        sections: {
            type: Array,
            required: false
        }
        // form: {
        //   type: Object,
        //   required: true
        // }
    },
    data: () => ({
        editName: true, // TODO: make editable by clicking on pencil icon
        editAddress: false
    }),
    components: {
        ShippingMethod,
        AddressForm,
        Address,
        Multiselect
    },
    computed: {
        desiredDeliveryDateSection() {
            const sections = this.sections || [];
            const section = sections.find(el => el.key === 'should-be-delivered-at');
            return section;
        },
        desiredDeliveryDateRequired() {
            let required = true; // default value: true

            const settings = get(this.desiredDeliveryDateSection, 'settings') || [];
            const setting = settings.find(el => el.key === 'required');
            if (setting) {
                required = ['true', '1', 'yes', true].includes(setting.value);
            }

            return required;
        },
        desiredDeliveryDateRules() {
            let rules = [];
            if (this.desiredDeliveryDateRequired) rules.push('required');
            return rules.join('|');
        },
        desiredDeliveryDateOptions() {
            let options = [];

            const settings = get(this.desiredDeliveryDateSection, 'settings') || [];
            const setting = settings.find(el => el.key === 'date-options');
            if (setting && setting.options && setting.options.length) {
                options = setting.options.map(el => {
                    const key = date2timestamp(el.key);
                    const value = el.value;
                    const label = formatTimestamp(key, 'PPPP');
                    return { key, value, label };
                });
            }

            return options;
        },
        shouldBeDeliveredAt: {
            get() {
                if (this.checkout.form.should_be_delivered_at !== undefined) {
                    const key = this.checkout.form.should_be_delivered_at;
                    const value = formatTimestamp(key, 'P');
                    const label = formatTimestamp(key, 'PPPP');
                    return { key, value, label };
                } else {
                    return undefined;
                }
            },
            set(data) {
                this.setShouldBeDeliveredAtTimestamp(data?.key);
            }
        },

        addresses() {
            return this.addressOptions.shipping;
        },
        shippingAddress() {
            return this.checkout.form.account.shipping_address;
        },
        showAddressForm() {
            if (this.isAuthenticated && this.addresses.length) {
                return get(this.shippingAddress, 'id', '').startsWith('new:');
            } else {
                return this.editAddress;
            }
        },
        currency() {
            return (
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR'
            );
        },
        methods() {
            return this.shippingMethodOptions || [];
        },
        shipping: {
            get() {
                return this.checkout.form.shipping;
            },
            set(value) {
                this.setShipping(value);
            }
        },
        ...mapGetters({
            customer: 'shop/customer',
            isAuthenticated: 'auth/isAuthenticated',
            defaultCustomerGroup: 'shop/defaultCustomerGroup',
            shippingMethodOptions: 'shop/shippingMethodOptions',
            addressOptions: 'shop/addressOptions',
            shippingFee: 'shop/shippingFee',
            checkout: 'shop/checkout'
        })
    },
    methods: {
        select(method) {
            this.shipping = method;
        },
        ...mapMutations({
            setShipping: 'shop/setCheckoutFormShipping',
            setShippingAddress: 'shop/setCheckoutFormShippingAddress',
            setShouldBeDeliveredAtTimestamp: 'shop/setShouldBeDeliveredAtTimestamp'
        })
    },
    mounted() {
        if (!this.shipping.id && this.methods.length >= 1) {
            this.shipping = this.methods[0];
        }

        // fill address if guest or if not address options
        if (!this.shippingAddress.id) {
            const account = this.checkout.form.account;
            let address = cloneDeep(account.billing_address);
            address.id = uniqid('new:');

            // address.gender = account.gender;
            // address.first_name = account.first_name;
            // address.last_name = account.last_name;
            // address.phone = account.phone;
            // address.mobile = account.mobile;
            // address.email = account.email;

            this.setShippingAddress(address);
        }
    }
};
</script>

<style lang="sass" scoped>
.shipping-step
  & > .alert
    margin-top: -2rem
  .overflow-visible
    overflow: visible !important
  .desired-delivery-date
    .preview
      grid-gap: .2rem !important
    .help
      @apply text-gray-700
      font-size: .75em
      margin-top: 6px
      &.is-danger
        @apply text-red-500
    .panel.error .icon
      @apply text-red-500
    ::v-deep
      .multiselect
        position: relative
        bottom: -1px
        .multiselect__tags
          border: none
          background: none
        .multiselect__single
          background: none
          font-weight: 500
</style>
